import { ComparisonOperators } from '../types/carrierQuestionnaire/conditions/operators';
export function isConditions(condition) {
    return typeof condition.conditions !== 'undefined';
}
export function isConditionSingleField(condition) {
    return typeof condition.nodeId !== 'undefined';
}
export function isConditionQuery(condition) {
    return typeof condition.query !== 'undefined';
}
export function hasControlValue(condition) {
    return typeof condition.controlValue !== 'undefined';
}
export function hasControlValueQuery(condition) {
    return typeof condition.controlValueQuery !== 'undefined';
}
export function isConditionCollection(condition) {
    return (typeof condition.collection !== 'undefined' &&
        typeof condition.collectionOperator !== 'undefined');
}
// Helpers for common conditions
export function fieldValueIsTrueBool(nodeId) {
    return {
        nodeId,
        operator: ComparisonOperators.equal,
        value: true,
    };
}
export function fieldValueMaximumCharacters(nodeId, maxCharacters) {
    return {
        nodeId,
        operator: ComparisonOperators.characterCountBetween,
        value: [-1, maxCharacters + 1],
    };
}
export function fieldValueMinimumCharacters(nodeId, minCharacters) {
    return {
        nodeId,
        operator: ComparisonOperators.characterCountBetween,
        value: [minCharacters - 1, Number.MAX_SAFE_INTEGER],
    };
}
